module.exports = __webpack_public_path__ + "img/ic_map_cluster_hotels_label_es.ab612592.svg";